<div class="modal-comentarios">
  <ng-container *ngIf="data.idNoticia">
    <app-comentarios [idVideo]="data.idNoticia"></app-comentarios>
  </ng-container>
</div>
